import { getFirestore, doc, setDoc, arrayUnion } from "firebase/firestore"
import getCollectionPath from '@/assets/functions/getCollectionPath'
import downloader from '@/assets/functions/downloader'
import Log from '@/classes/Log'

const db = getFirestore()
const collectionName = 'logs/'

// Les logs sont répartis dans un document par utilisateur et par jour ("<userId>_<AAAA-MM-JJ>") :
// un document unique grossissait sans fin et finissait par dépasser la limite de 1 Mo de Firestore.
function dayKey(date) {
  let d = new Date(date)
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0')
}

// Ajout atomique (arrayUnion + merge) : deux écritures simultanées ne s'écrasent plus
async function append(userId, field, values, date) {
  if (!userId || !values || values.length == 0) return
  let day = dayKey(date)
  let docRef = doc(db, await getCollectionPath(collectionName), userId + '_' + day)
  await setDoc(docRef, {
    user: userId,
    day: day,
    [field]: arrayUnion(...values),
  }, { merge: true })
}

async function getAllForUser(userId) {
  let docs = (await Log.getByUser(userId)).filter(Boolean)
  let logs = []
  let pings = []
  for (let currentLog of docs) {
    logs = logs.concat(currentLog.logs || [])
    pings = pings.concat(currentLog.pings || [])
  }
  logs.sort((a, b) => a.date - b.date)
  pings = [...new Set(pings)].sort((a, b) => a - b)
  return { logs, pings }
}

function csvCell(value) {
  let text = String(value === undefined || value === null ? '' : value)
  if (/[",;\n\r]/.test(text)) {
    text = '"' + text.replaceAll('"', '""') + '"'
  }
  return text
}

function downloadCsv(rows, name) {
  // BOM pour qu'Excel lise correctement les accents
  let content = '﻿' + rows.map(row => row.map(csvCell).join(',')).join('\n')
  downloader.downloadBlob(new Blob([content], { type: 'text/csv;charset=utf-8' }), name)
}

let logger = {
  async log(userId, type, target, message) {
    let now = new Date().getTime()
    try {
      await append(userId, 'logs', [{
        date: now,
        type: type,
        target: target,
        message: message,
      }], now)
    } catch (error) {
      console.error('[logger] log', error)
    }
  },

  async ping(userId) {
    await logger.multiPing(userId, [new Date().getTime()])
  },

  async multiPing(userId, dates) {
    if (!dates || dates.length == 0) return
    // Une activité par minute suffit : on n'enregistre plus chaque clic / touche
    let minutesByDay = {}
    for (let date of dates) {
      let minute = Math.floor(date / 60000) * 60000
      let day = dayKey(minute)
      if (!minutesByDay[day]) minutesByDay[day] = new Set()
      minutesByDay[day].add(minute)
    }
    try {
      await Promise.all(Object.values(minutesByDay).map(minutes => {
        let values = [...minutes]
        return append(userId, 'pings', values, values[0])
      }))
    } catch (error) {
      console.error('[logger] multiPing', error)
    }
  },

  async downloadLogs(userId) {
    let { logs } = await getAllForUser(userId)
    let rows = [['Date', 'Type', 'Cible', 'Message']]
    for (let log of logs) {
      rows.push([new Date(log.date).toLocaleString(), log.type, log.target, log.message])
    }
    downloadCsv(rows, 'logs.csv')
  },

  async downloadPings(userId) {
    let { pings } = await getAllForUser(userId)
    let rows = [['Date']]
    for (let ping of pings) {
      rows.push([new Date(ping).toLocaleString()])
    }
    downloadCsv(rows, 'pings.csv')
  }
}

export default logger
